<template>
  <div class="save-button-container tw-z-50" v-if="dossierStore.isEditing && dossierStore.hasUnsavedChanges">
    <div class="save-button-wrapper">
      <Button
        variant="primary"
        size="4"
        @click="saveDossier"
        :disabled="isSaving"
        :loader="isSaving"
      >
        <div class="save-button-content">
          {{ isSaving ? 'Saving...' : 'Save Changes' }}
        </div>
      </Button>

      <Button
        variant="danger"
        @click="dossierStore.cancelChanges()"
        size="4"
        :disabled="isSaving"
      >
        Cancel
      </Button>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { Button } from '@stakeui';
import { useDossierStore } from '../../../stores/dossierStore';

const dossierStore = useDossierStore();
const isSaving = ref(false);
const emit = defineEmits(['save-started', 'save-completed', 'save-failed']);

const props = defineProps({
  entityExternalId: {
    type: String,
    required: true,
  },
});

async function saveDossier() {
  try {
    isSaving.value = true;
    emit('save-started');

    const response = await fetch(`/api/v1/dossier/entity/${props.entityExternalId}/save/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRFToken': document.querySelector('[name="csrfmiddlewaretoken"]').value,
      },
      body: JSON.stringify({
        dossier_data: dossierStore.currentValue,
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to save dossier');
    }

    const data = await response.json();

    // Update the original value to match the current one
    dossierStore.updateOriginalValue();
    // Reset unsaved changes flag
    dossierStore.toggleUnsavedChanges(false);
    // Revert to "view" mode
    dossierStore.setEditMode(false);
    emit('save-completed', data);
  } catch (error) {
    console.error('Error saving dossier:', error);
    emit('save-failed', error);
  } finally {
    isSaving.value = false;
  }
}
</script>

<style scoped>
.save-button-container {
  background-color: hsl(0deg 0% 90% / 50%);
  position: sticky;
  border-radius: 1rem;
  margin-top: 1.5rem;
  bottom: 1rem;
  padding: 1rem;
  display: flex;
  backdrop-filter: blur(4px);
}

.save-button-wrapper {
  display: flex;
  justify-content: start;
  align-items: start;
  gap: 1em;
  flex-grow: 1;
}

.save-button-content {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style> 
